import type { CSSObject } from "@emotion/serialize";

export const clearButtonDecoration = (): CSSObject => {
  return {
    padding: 0,
    border: "none",
    backgroundColor: "inherit",
    cursor: "pointer",
    textAlign: "left",
  };
};
